// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экран 14 «Баланс и расход» (утверждён 28.10.2026). */
.bl-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.bl-period {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.bl-seg {
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}
.bl-seg button {
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  color: var(--v2-muted);
  cursor: pointer;
  white-space: nowrap;
}
.bl-seg button.is-on {
  background: #fff;
  color: var(--v2-primary);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.bl-dates {
  height: 36px;
  border-radius: 9px;
}
.bl-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 1180px) {
  .bl-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.bl-tile {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.bl-tile-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.v2-btn.bl-mini {
  height: 26px;
  padding: 0 10px;
  font-size: 12px;
}
.bl-big {
  font-size: 22px;
  white-space: nowrap;
}
.bl-up {
  color: #c2410c;
  font-size: 12px;
  font-weight: 600;
}
.bl-down {
  color: var(--v2-green-text);
  font-size: 12px;
  font-weight: 600;
}
.bl-chart {
  padding: 0;
  overflow: hidden;
}
.bl-chart > .dl-chart {
  border-top: 0;
}
.bl-card {
  padding: 0;
  overflow: hidden;
}
.bl-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 16px;
}
.bl-period-txt {
  font-weight: 400;
  font-size: 13px;
}
.bl-tabs {
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
}
.bl-tabs button {
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid var(--v2-border);
  background: #fff;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.bl-tabs button.is-on {
  background: var(--v2-primary);
  border-color: var(--v2-primary);
  color: #fff;
}
.bl-table {
  min-width: 680px;
}
.bl-table th,
.bl-table td {
  white-space: nowrap;
}
.bl-details {
  white-space: normal !important;
  min-width: 220px;
  color: var(--v2-text-2);
}
.bl-ops {
  max-height: 560px;
  overflow-y: auto;
}
.bl-plus {
  color: var(--v2-green-text);
}
.bl-foot {
  padding: 10px 16px 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/billing-v2/billing-v2.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB","sourcesContent":["/* Экран 14 «Баланс и расход» (утверждён 28.10.2026). */\n.bl-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.bl-period {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.bl-seg {\n  display: inline-flex;\n  background: #f3f4f6;\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n}\n.bl-seg button {\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 8px;\n  color: var(--v2-muted);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.bl-seg button.is-on {\n  background: #fff;\n  color: var(--v2-primary);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n.bl-dates {\n  height: 36px;\n  border-radius: 9px;\n}\n.bl-tiles {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n@media (max-width: 1180px) {\n  .bl-tiles {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.bl-tile {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.bl-tile-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n.v2-btn.bl-mini {\n  height: 26px;\n  padding: 0 10px;\n  font-size: 12px;\n}\n.bl-big {\n  font-size: 22px;\n  white-space: nowrap;\n}\n.bl-up {\n  color: #c2410c;\n  font-size: 12px;\n  font-weight: 600;\n}\n.bl-down {\n  color: var(--v2-green-text);\n  font-size: 12px;\n  font-weight: 600;\n}\n.bl-chart {\n  padding: 0;\n  overflow: hidden;\n}\n.bl-chart > .dl-chart {\n  border-top: 0;\n}\n.bl-card {\n  padding: 0;\n  overflow: hidden;\n}\n.bl-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 16px;\n}\n.bl-period-txt {\n  font-weight: 400;\n  font-size: 13px;\n}\n.bl-tabs {\n  display: inline-flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.bl-tabs button {\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid var(--v2-border);\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.bl-tabs button.is-on {\n  background: var(--v2-primary);\n  border-color: var(--v2-primary);\n  color: #fff;\n}\n.bl-table {\n  min-width: 680px;\n}\n.bl-table th,\n.bl-table td {\n  white-space: nowrap;\n}\n.bl-details {\n  white-space: normal !important;\n  min-width: 220px;\n  color: var(--v2-text-2);\n}\n.bl-ops {\n  max-height: 560px;\n  overflow-y: auto;\n}\n.bl-plus {\n  color: var(--v2-green-text);\n}\n.bl-foot {\n  padding: 10px 16px 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
